"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    cleanTableProps: ()=>cleanTableProps
});
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const tdPropsToClean = [
    'textWrap',
    'lineClamp',
    'maxWidth',
    'wordBreak',
    'size',
    'align',
    'contentClassName'
];
const thPropsToClean = [
    'sort',
    "description",
    'interactive',
    'sticky'
];
const trPropsToClean = [
    'striped',
    'cellLineClamp',
    'cellMaxWidth',
    'cellSize',
    'cellTextWrap',
    'cellWordBreak',
    'tableBordered',
    'color',
    'isGroupHeader'
];
const tablePropsToClean = [
    ...tdPropsToClean,
    ...thPropsToClean,
    ...trPropsToClean,
    'bordered',
    'scrollable',
    'firstColumnSticky',
    'headerCellInteractive',
    'headerSticky',
    'scrollClassName',
    'loading',
    'maxColumns'
];
const cleanTableProps = (props)=>(0, index_cjs_namespaceObject.cleanProps)(props, tablePropsToClean);
exports.cleanTableProps = __webpack_exports__.cleanTableProps;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "cleanTableProps"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
